import { CommandType } from "~app/common/services/cqs/CommandType";
import { KontraktBilagaCommandBase } from "./KontraktBilagaCommandBase";

export class UpdateKontraktBilagaCommand extends KontraktBilagaCommandBase {

    readonly synligForKopplanera: boolean;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "UpdateKontraktBilagaCommand";

    constructor(dokumentId: number, synligForKopplanera: boolean) {
        super(UpdateKontraktBilagaCommand.$type, CommandType.Replace);
        this.dokumentId = dokumentId;
        this.synligForKopplanera = synligForKopplanera;
    }
}
